<template>
	<div class="pause-page">
		<div class="pause_bg">
			<div class="pause_contain">
				<div class="pause_title_t">
					<span>今日线上申请人数<span class="text_red">已满</span><br/>请到医院病案室窗口进行办理</span>
					<!-- <img src="../assets/pause-text.svg" /> -->
				</div>
				<div class="pause_tip_t">
					<span>如不着急办理，可第二天申请</span>
					返回<span class="back_hoslist" @click="onShowHospitalList">【医院列表】</span>
				</div>
				<div class="pause_image">
					<img src="../assets/pause_background.png" />
				</div>
				<div class="pause_address">
					<div class="pause_address_title">
						<img src="../assets/pause_address.png" />
						病案室窗口位置：
					</div>
					<div class="pause_address_contain">
						郑州市二七区建设东路一号郑大一附院9号楼负一楼病案管理科
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		created() {
			
		},
		methods:{
			onShowHospitalList(){
				this.$router.push('hos-list')
			}
		}
	}
</script>

<style>
	.pause_bg {
		background: white;
		width: 100%;
		height: 100vh;
	}

	.pause_contain {
		width: 90%;
		margin: 0px auto;
		padding-top: 40px;

	}

	.pause_title_t {
		width: 100%;
		text-align: center;
		font-size: 24px;
	}
	.pause_title_t img{
		width: 320px;
		height: 80px;
	}

	.text_red {
		color: red;
	}

	.pause_tip_t {
		width: 213px;
		text-align: left;
		margin: 15px auto;
		padding: 5px 5px;
		background: #E8F6E8;
	}

	.back_hoslist {
		color: #1AAD19;
	}

	.pause_image {
		width: 316px;
		height: 194px;
		margin: 40px auto;
	}

	.pause_image img {
		width: 315px;
		height: 194px;
	}

	.pause_address {
		position: fixed;
		bottom: 40px;
		left: 20px;
		right: 20px;
	}

	.pause_address_title {
		margin-left: 15px;
		line-height: 32px;
	}

	.pause_address_title img {
		/* padding-top:3px;  */
		width: 25px;
		height: 25px;
	}

	.pause_address_contain {
		background: #F3FCFF;
		padding: 15px 15px;
	}
</style>
